import { render, staticRenderFns } from "./fans.vue?vue&type=template&id=d1e5511a&scoped=true&"
import script from "./fans.vue?vue&type=script&lang=js&"
export * from "./fans.vue?vue&type=script&lang=js&"
import style0 from "./fans.vue?vue&type=style&index=0&id=d1e5511a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1e5511a",
  null
  
)

export default component.exports